import { AppThunkAction } from "..";
import { KnownAction, GET_BILLING_STATUS, LOADER_FOR_BILLING_STATUS } from "./types";
import * as httpClient from "../../util/httpClient";

export const actionCreators = {
    getBillingStatus:
        (needToRefresh?: boolean): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const state = getState();
                if (
                    state.billingStatusState &&
                    state.billingStatusState.isBillingStatusLoaded === false &&
                    needToRefresh
                ) {
                    httpClient
                        .sendRequest("GET", "web/user/GetUserBillingStatus")
                        .then((data) => {
                            dispatch({ type: GET_BILLING_STATUS, billingStatus: data });
                            dispatch({ type: LOADER_FOR_BILLING_STATUS, isBillingStatusLoaded: true });
                        })
                        .catch(function (error) {
                            dispatch({ type: LOADER_FOR_BILLING_STATUS, isBillingStatusLoaded: false });
                        });
                }
            }
};
